import { render, staticRenderFns } from "./TokenConfirm.vue?vue&type=template&id=6dc1869a&"
import script from "./TokenConfirm.vue?vue&type=script&lang=js&"
export * from "./TokenConfirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports